import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { environment } from '@env/environment';

@Injectable()
export class AuthRequestInterceptor implements HttpInterceptor {
  backendMatch;

  constructor(private injector: Injector) {
    this.backendMatch = new RegExp(`^${ environment.api.backend }`, 'i');
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authService = this.injector.get(AuthService);
    const { token } = authService.getToken() || '';
    const currentCompany = authService.getCurrentCompany();

    // intercept only if matches
    if (!(request.url || '').match(this.backendMatch)) {
      return next.handle(request);
    }

    if (token?.access_token) {
      request = request.clone({
        // withCredentials: true,
        setHeaders: {
          Authorization: `${ token.token_type } ${ token.access_token }`,
          Company: currentCompany,
          System: environment.system,
        }
      });
    } else {
      request = request.clone({
        // withCredentials: true,
        setHeaders: {
          System: environment.system,
        }
      });
    }

    return next.handle(request);
  }
}
